export interface MediaItem {
  name: string;
  description: string;
  url?: string;
  content?: string;
}

export enum ProductName {
  TrialMax = 'TrialMax',
  RaterStation = 'Rater Station',
}

export interface Tab {
  label: TabName;
  productcode: string;
  folder: string;
  enabled: boolean;
  files: MediaFile[];
}

export interface Product {
  label: string;
  productcode: string;
  enabled: boolean;
}

export interface ProductContentProps {
  product: Product;
  tabs: Tab[];
}

export interface MediaFile {
  fileType: string;
  url?: string;
  title: string;
  description?: string;
  content?: string;
  duration?: string;
}

export interface MediaProps {
  name: string;
  createdDate: string;
  duration?: string;
  url?: string;
  fetchUrl?: () => Promise<string>;
  id?: string;
  fileType?: string;
  description?: string;
}

export enum TabName {
  'TRIAL_MANAGER' = 'TRIAL MANAGER',
  'APP' = 'APP',
  'TOUCH' = 'TOUCH',
  'SLATE' = 'SLATE',
  'WEB' = 'WEB',
  'LOGISTICS' = 'LOGISTICS',
  'DEVICE_MANAGER' = 'DEVICE MANAGER',
  'STUDYIQ_VIDEOS' = 'STUDYIQ VIDEOS',
  'CLIENT' = 'CLIENT',
  'COLLECTOR' = 'COLLECTOR',
}

export enum MediaType {
  Audio = 'audio',
  Video = 'video',
  Image = 'image',
  Pdf = 'pdf',
  Text = 'text',
}
